var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Redesign-scoped markdown renderer for the drop / campaign description body (Overview section).
// The legacy drop page (src/client/web/record/DropEvent/HeroSection.js) renders gameDescriptionBody
// via react-markdown + remark-gfm with the legacy MARKDOWN_COMPONENTS (src/client/util/markdown.tsx),
// which uses legacy tokens (text-link, border-dark-1) and plain heading sizes. This is a fresh map on
// the redesign palette: Sora (font-display) headings, muted-foreground body, neon-cyan links. Unlike
// NOTIFICATION_MARKDOWN_COMPONENTS (headings collapsed to tiny spans for compact notifications), this
// keeps real heading hierarchy because the description is long-form body content. New component, both
// legacy maps untouched (A/B).
export const DROP_DESCRIPTION_MARKDOWN_COMPONENTS = {
    p: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<p {...props} className="text-sm leading-relaxed text-muted-foreground [&:not(:first-child)]:mt-4">{props.children}</p>);
    },
    a: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<a {...props} href={props.href} target="_blank" rel="noopener noreferrer" className="font-medium text-neon-cyan underline underline-offset-2 transition-opacity hover:opacity-80">
			{props.children}
		</a>);
    },
    strong: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<strong {...props} className="font-semibold text-foreground">{props.children}</strong>);
    },
    em: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<em {...props} className="italic">{props.children}</em>);
    },
    h1: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<h1 {...props} className="font-display text-xl font-bold text-foreground [&:not(:first-child)]:mt-6">{props.children}</h1>);
    },
    h2: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<h2 {...props} className="font-display text-lg font-bold text-foreground [&:not(:first-child)]:mt-6">{props.children}</h2>);
    },
    h3: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<h3 {...props} className="font-display text-base font-semibold text-foreground [&:not(:first-child)]:mt-5">{props.children}</h3>);
    },
    h4: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<h4 {...props} className="font-display text-sm font-semibold text-foreground [&:not(:first-child)]:mt-4">{props.children}</h4>);
    },
    h5: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<h5 {...props} className="font-display text-sm font-semibold text-foreground [&:not(:first-child)]:mt-4">{props.children}</h5>);
    },
    h6: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<h6 {...props} className="font-display text-xs font-semibold text-foreground [&:not(:first-child)]:mt-4">{props.children}</h6>);
    },
    ul: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<ul {...props} className="my-4 list-inside list-disc space-y-1 text-sm text-muted-foreground">{props.children}</ul>);
    },
    ol: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<ol {...props} className="my-4 list-inside list-decimal space-y-1 text-sm text-muted-foreground">{props.children}</ol>);
    },
    li: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<li {...props} className="leading-relaxed">{props.children}</li>);
    },
    blockquote: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<blockquote {...props} className="my-4 border-l-2 border-solid border-border pl-4 text-sm italic text-muted-foreground">{props.children}</blockquote>);
    },
    code: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<code {...props} className="rounded bg-white/[0.06] px-1.5 py-0.5 text-xs text-foreground">{props.children}</code>);
    },
    hr: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<hr {...props} className="my-6 border-t border-solid border-border"/>);
    },
};
